import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { FacetPicker } from '../components/FacetPicker.js';
import { FacetWithImage } from '../components/FacetWithImage.js';

const FacetPickerColor = ({ onPick , activeFacet , items , className , enableStockIndicator , productType ,  })=>{
    const { getLabel  } = useIntl();
    if (items.length === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(FacetPicker, {
        itemComponent: FacetWithImage,
        items: items,
        onPick: onPick,
        title: getLabel('products.facets.frameColor.title'),
        productType: productType,
        activeFacet: activeFacet,
        showFacetName: true,
        className: className,
        enableStockIndicator: enableStockIndicator
    });
};

export { FacetPickerColor };
//# sourceMappingURL=FacetPickerColor.js.map
